module.exports = __webpack_public_path__ + "media/hero.52dc23cd.mp4";